import * as React from "react";
import {
  FormatAlignCenterRounded,
  FormatAlignJustifyRounded,
  FormatAlignLeftRounded,
  FormatAlignRightRounded,
  FormatClearRounded,
  FormatStrikethroughRounded,
  FormatUnderlinedRounded,
} from "@mui/icons-material";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "./elements.settings";

const { "Thème & Couleurs": THEME, ...REST } = ELEMENTS_GUI_FIELDS;

export const X_TEXT_GUI_FIELDS: TXGUISection = {
  Général: [
    { type: "text", name: "text", label: "Donnee" },
    {
      type: "select_option",
      name: "tag",
      label: "Composant",
      options: [
        { value: "body1", label: "Paragraphe 1" },
        { value: "body2", label: "Paragraphe 2" },
        { value: "h1", label: "Heading 1 (h1)" },
        { value: "h2", label: "Heading 2 (h2)" },
        { value: "h3", label: "Heading 3 (h3)" },
        { value: "h4", label: "Heading 4 (h4)" },
        { value: "h5", label: "Heading 5 (h5)" },
        { value: "h6", label: "Heading 6 (h6)" },
        { value: "subtitle1", label: "Sous-Titre 1" },
        { value: "subtitle2", label: "Sous-Titre 2" },
        { value: "caption", label: "Caption" },
        { value: "overline", label: "Overline" },
      ],
      defaultValue: "body1",
    },
  ],
  "Thème & Couleurs": [
    // {
    //   type: "font",
    //   name: "fontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "select_option",
      name: "fontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },
    {
      type: "toggle_option",
      name: "fontStyle",
      label: "Style de la police",
      options: [{ value: "normal" }, { value: "italic" }],
      defaultValue: "normal",
    },
    {
      type: "color",
      name: "color",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    {
      type: "sizing",
      name: "lineHeight",
      label: "Hauteur de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt", "auto"],
    },
    {
      type: "sizing",
      name: "letterSpacing",
      label: "Espacement des lettres",
      placeholder: "10",
      units: ["px", "em"],
    },
    {
      type: "sizing",
      name: "fontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
    {
      type: "toggle_option",
      name: "textAlign",
      label: "Alignement du texte",
      options: [
        { value: "left", label: "Gauche", icon: <FormatAlignLeftRounded /> },
        {
          value: "center",
          label: "Centre",
          icon: <FormatAlignCenterRounded />,
        },
        { value: "right", label: "Droite", icon: <FormatAlignRightRounded /> },
        {
          value: "justify",
          label: "Remplir",
          icon: <FormatAlignJustifyRounded />,
        },
      ],
      defaultValue: "left",
    },
    {
      type: "toggle_option",
      name: "textDecoration",
      label: "Decoration",
      options: [
        { value: "none", label: "Aucune", icon: <FormatClearRounded /> },
        {
          value: "underline",
          label: "Souligner",
          icon: <FormatUnderlinedRounded />,
        },
        {
          value: "line-through",
          label: "Barrer",
          icon: <FormatStrikethroughRounded />,
        },
      ],
      defaultValue: "none",
    },
    ...(THEME ?? []),
  ],
  ...REST,
};

// {
//   type: "select_option",
//   name: "href",
//   label: "Naviger vers",
//   options: [
//     { value: "NONE", label: "Aucune Page" },
//     { value: "/", label: "Page d'Accueil" },
//     { value: "/shop", label: "Page Boutique" },
//     { value: "/categories/[slug]", label: "Page Categorie" },
//     { value: "/about-us", label: "Page A Propos de nous" },
//     { value: "/contact-us", label: "Page Contactez-nous" },
//     { value: "/blog", label: "Page Blog" },
//     { value: "/blog/[slug]", label: "Page Blog Article" },
//     { value: "/checkout", label: "Page Payement" },
//     { value: "/products/[slug]", label: "Page Detail du Produit" },
//   ],
//   defaultValue: "NONE",
// },
